import { GridColDef } from "@mui/x-data-grid";
import { Option } from "../../../../../constants/common";
import { applyDefaultColumnSettings } from "../../../../../utils/utils";

// ─── Types ───────────────────────────────────────────────────────────────────

export interface BillingReportFilterData {
  date_range?: string;
  startDate?: string;
  endDate?: string;
  provider_Name?: string;
  location?: string;
  claim_Status?: string;
  insurance?: string;
}

export const DEFAULT_BILLING_FILTERS: BillingReportFilterData = {
  date_range: undefined,
  startDate: undefined,
  endDate: undefined,
  provider_Name: undefined,
  location: undefined,
  claim_Status: undefined,
  insurance: undefined,
};

// ─── Status Color Mapping ────────────────────────────────────────────────────

export const BILLING_STATUS_MAP: Record<
  string,
  { label: string; color: string; bgColor: string }
> = {
  PAID: { label: "Paid", color: "#049B22", bgColor: "#E1FCDE" },
  ACCEPTED: { label: "Accepted", color: "#3538CD", bgColor: "#EEF4FF" },
  PENDING: { label: "Pending", color: "#943C00", bgColor: "#FFF2D2" },
  SUBMITTED: { label: "Submitted", color: "#004AB1", bgColor: "#E0EDFF" },
  REJECTED: { label: "Rejected", color: "#FF3939", bgColor: "#FFE1E0" },
  DENIED: { label: "Denied", color: "#B93815", bgColor: "#FEF6EE" },
};

// ─── Status filter options ───────────────────────────────────────────────────

export const BILLING_STATUS_OPTIONS: Option[] = [
  { value: "PAID", label: "Paid" },
  { value: "ACCEPTED", label: "Accepted" },
  { value: "PENDING", label: "Pending" },
  { value: "SUBMITTED", label: "Submitted" },
  { value: "REJECTED", label: "Rejected" },
  { value: "DENIED", label: "Denied" },
];

// ─── Table Column Definitions ────────────────────────────────────────────────

const SORTABLE_FIELDS = ["dateOfService", "billed", "paid", "claimStatus"];

export const getBillingColumns = (
  renderClaimId: (params: any) => JSX.Element,
  renderCptCode: (params: any) => JSX.Element,
  renderStatusCell: (params: any) => JSX.Element
): GridColDef[] =>
  applyDefaultColumnSettings(
    [
      {
        field: "uuid",
        headerName: "Claim ID",
        flex: 1,
        minWidth: 130,
        renderCell: renderClaimId,
      },
      {
        field: "dateOfService",
        headerName: "Date of Service",
        flex: 1,
        minWidth: 140,
      },
      {
        field: "patientName",
        headerName: "Patient Name",
        flex: 0.6,
        minWidth: 100,
      },
      {
        field: "providerName",
        headerName: "Provider",
        flex: 0.8,
        minWidth: 110,
      },
      {
        field: "insuranceName",
        headerName: "Insurance",
        flex: 1.5,
        minWidth: 160,
      },
      {
        field: "cptCode",
        headerName: "CPT Code",
        flex: 1.3,
        minWidth: 150,
        renderCell: renderCptCode,
      },
      {
        field: "billed",
        headerName: "Billed",
        flex: 0.8,
        minWidth: 110,
      },
      {
        field: "paid",
        headerName: "Paid",
        flex: 0.8,
        minWidth: 110,
      },
      {
        field: "claimStatus",
        headerName: "Status",
        flex: 0.9,
        minWidth: 110,
        renderCell: renderStatusCell,
      },
    ],
    SORTABLE_FIELDS
  );

// ─── KPI Card Definitions ────────────────────────────────────────────────────

export interface BillingKPICardConfig {
  key: string;
  label: string;
  valueKey: string;
  format: "number" | "currency" | "days" | "percent";
}

export const BILLING_KPI_CARDS: BillingKPICardConfig[] = [
  {
    key: "totalClaims",
    label: "Total Claims",
    valueKey: "totalClaims",
    format: "number",
  },
  {
    key: "totalBilled",
    label: "Total Billed",
    valueKey: "totalBilled",
    format: "currency",
  },
  {
    key: "totalPaid",
    label: "Total Paid",
    valueKey: "totalPaid",
    format: "currency",
  },
  // {
  //   key: "avgDaysToPay",
  //   label: "Avg. Days\nto Pay",
  //   valueKey: "avgDaysToPay",
  //   format: "days",
  // },
  // {
  //   key: "cleanClaimRate",
  //   label: "Clean Claim\nRate",
  //   valueKey: "cleanClaimRate",
  //   format: "percent",
  // },
  // {
  //   key: "denialRate",
  //   label: "Denial Rate",
  //   valueKey: "denialRate",
  //   format: "percent",
  // },
];
